import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { useTranslations } from '@libs/translations';
import { TitleCard } from './title-card';
import { DescriptionCard } from './description-card';
import { Points } from '@styles';

export const CameraLighting = () => {
  const translations = useTranslations();
  return (
    <View>
      <Content>
        <TitleCard text={translations.t('site.home.opportunities.camera-lighting.title')} />
        <DescriptionCard text={translations.t('site.home.opportunities.camera-lighting.description')} />
      </Content>
    </View>
  );
};

const View = styled.div`
  position: relative;
  padding: 16px 16px 40px;
  height: 380px;
  color: ${Colors.white};
  border-radius: 15.13px;
  background: image-set(
        url('/images/mainpage/camera-lightining-bg.webp') type('image/webp'),
        url('/images/mainpage/camera-lightining-bg.png') type('image/png')
      )
      25% -5% / 168% no-repeat,
    ${Colors.main_black};

  @media ${Points.tablet_landscape} {
    padding: 30px 30px 40px;
    background: image-set(
          url('/images/mainpage/camera-lightining-bg.webp') type('image/webp'),
          url('/images/mainpage/camera-lightining-bg.png') type('image/png')
        )
        25% -5% / 100% no-repeat,
      ${Colors.main_black};
  }

  @media ${Points.laptop_wide} {
    height: 500px;
    padding: 40px;
    border-radius: 20px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 10px;

  @media ${Points.tablet_landscape} {
    gap: 15px;
  }

  @media ${Points.laptop_wide} {
    gap: 20px;
  }
`;
